// Admin workspaces list + detail queries (server-side pagination).
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { useIsPlatformAdmin } from '../../../shared/scope/useCurrentScope.js';

import {
  getAdminWorkspaceById,
  getAdminWorkspaceDetailQueryKey,
  getAdminWorkspacesQueryKey,
  listAdminWorkspaces,
  type AdminWorkspacesFilters,
} from '../api/admin.client.js';

export function useAdminWorkspaces(filters: AdminWorkspacesFilters) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminWorkspacesQueryKey(filters),
    queryFn: () => listAdminWorkspaces(filters),
    enabled: isPlatformAdmin,
    // Page/filter changes keep the previous rows visible instead of flashing
    // a skeleton — same contract as the users screen.
    placeholderData: keepPreviousData,
  });
}

export function useAdminWorkspaceDetail(workspaceId: string | null) {
  const isPlatformAdmin = useIsPlatformAdmin();

  return useQuery({
    queryKey: getAdminWorkspaceDetailQueryKey(workspaceId ?? 'none'),
    queryFn: () => getAdminWorkspaceById(workspaceId ?? ''),
    enabled: isPlatformAdmin && workspaceId !== null,
  });
}
